/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 29/04/2025 17:34
 *
 */

import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import {
  ActionEvent,
  DataModel,
  DialogType,
  Factory,
  RestService,
  StandardAction,
  StandardEntity,
} from '@infodata-group/inf-commons';
import { ICrud } from '../interface/crud.interface';
import {
  ActionsBarBuilder,
  ActionsBarComponent,
  DetailsComponent,
  DialogComponent,
} from '@infodata-group/inf-commons-desktop';
import { TranslateModule } from '@ngx-translate/core';

const EDIT = new StandardAction('edit', 'edit', '', 'Editer');
const DELETE = new StandardAction('delete', 'trash-alt', '', 'Supprimer');

@Component({
  selector: 'infl-standard-page-detail',
  standalone: true,
  imports: [
    TranslateModule,
    ActionsBarComponent,
    DetailsComponent,
    DialogComponent
],
  templateUrl: './standard-page-detail.component.html',
  styleUrl: './standard-page-detail.component.scss',
})
export class StandardPageDetailComponent<T extends StandardEntity>
  implements OnChanges
{
  private restService = inject(RestService);

  @Input({ required: true }) model: DataModel;
  @Input({ required: true }) factory: Factory<T>;
  @Input({ required: true }) CRUD: ICrud;
  @Input({ required: true }) entity: T;

  @Output() actionClick = new EventEmitter<ActionEvent>();

  public actionBarConfig = new ActionsBarBuilder().setTitleStyle().build();
  public actions: StandardAction[] = [];
  public title = '';
  protected dialogType = DialogType;

  @ViewChild('dialogDelete') dialogDelete: DialogComponent;

  ngOnChanges(changes: SimpleChanges): void {
    if (Object.hasOwn(changes, 'entity')) {
      this.title = this.entity.getLabel()
        ? this.entity.getLabel()
        : 'i18n.commons-lib.standard-page.detail';
      this.initActions();
    }
  }

  public initActions() {
    if (this.CRUD.update) {
      EDIT.tooltip = 'i18n.commons-lib.standard-page.edit';
      this.actions = [EDIT];
    }
    if (this.CRUD.delete) {
      DELETE.tooltip = 'i18n.commons-lib.standard-page.delete';
      this.actions = [...this.actions, DELETE];
    }
  }

  public onClickActionBar(event: ActionEvent) {
    switch (event.action.name) {
      case 'edit':
        event.value = this.entity;
        this.actionClick.emit(event);
        break;
      case 'delete':
        this.onDelete();
        break;
    }
  }

  private onDelete() {
    this.dialogDelete.open();
  }

  public onActionDialogDelete(event: string) {
    if (event !== 'confirm') {
      return;
    }
    this.restService
      .delete(this.factory.getApi(), this.entity.getId())
      .subscribe({
        next: () => {
          this.actionClick.emit(
            new ActionEvent(
              'close',
              new StandardAction('deleteAndRefresh', ''),
            ),
          );
        },
        error: (e) => {
          throw Error(e);
        },
      });
  }
}
